import { render, staticRenderFns } from "./InspectionListAttachmentThumbnail.vue?vue&type=template&id=5f66dd03&scoped=true&"
import script from "./InspectionListAttachmentThumbnail.vue?vue&type=script&lang=ts&"
export * from "./InspectionListAttachmentThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionListAttachmentThumbnail.vue?vue&type=style&index=0&id=5f66dd03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f66dd03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VHover,VImg})
